/**
 * Shared side-cart opener for Free Life Labs conversion pages + wholesale buybox.
 * Fetches cart-drawer / cart-icon-bubble from the storefront ROOT (some templates
 * 404 on ?sections=). Never navigates to /cart or collections.
 * Beats conversion sticky z-index (2147482xxx) and hides .nr-sticky while open.
 */
(function (w) {
  "use strict";

  var STICKY_HIDE_CSS_ID = "fll-cart-drawer-sticky-hide";
  var DRAWER_Z = "2147483500";
  var closeObserver = null;

  function rootUrl() {
    try {
      return (w.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    } catch (e) {
      return "/";
    }
  }

  function injectStickyHideCss() {
    if (document.getElementById(STICKY_HIDE_CSS_ID)) return;
    try {
      var style = document.createElement("style");
      style.id = STICKY_HIDE_CSS_ID;
      style.textContent =
        "html.fll-cart-drawer-open .nr-sticky," +
        "body.fll-cart-drawer-open .nr-sticky," +
        "html.fll-cart-drawer-open [data-nr-sticky]," +
        "body.fll-cart-drawer-open [data-nr-sticky]{" +
        "display:none!important;visibility:hidden!important;pointer-events:none!important;" +
        "}" +
        "cart-drawer.drawer,cart-drawer.drawer.active,.drawer.active{" +
        "z-index:" + DRAWER_Z + "!important;" +
        "}";
      (document.head || document.documentElement).appendChild(style);
    } catch (e) {}
  }

  function bumpDrawerZ(drawer) {
    if (!drawer) return;
    try {
      drawer.style.setProperty("z-index", DRAWER_Z, "important");
    } catch (e) {}
  }

  function markOpen() {
    try {
      document.documentElement.classList.add("fll-cart-drawer-open");
      document.body.classList.add("fll-cart-drawer-open");
      document.body.classList.add("overflow-hidden");
    } catch (e) {}
    try {
      if (typeof CartDrawer !== "undefined" && CartDrawer && typeof CartDrawer.hideChatWidget === "function") {
        CartDrawer.hideChatWidget();
      }
    } catch (e2) {}
  }

  function markClosed() {
    try {
      document.documentElement.classList.remove("fll-cart-drawer-open");
      document.body.classList.remove("fll-cart-drawer-open");
      document.body.classList.remove("overflow-hidden");
    } catch (e) {}
    try {
      if (typeof CartDrawer !== "undefined" && CartDrawer && typeof CartDrawer.showChatWidget === "function") {
        CartDrawer.showChatWidget();
      }
    } catch (e2) {}
  }

  function ensureCloseObserver(drawer) {
    if (!drawer || closeObserver) return;
    try {
      closeObserver = new MutationObserver(function () {
        var d = document.querySelector("cart-drawer");
        if (!d) return;
        if (!d.classList.contains("active")) {
          markClosed();
        }
      });
      closeObserver.observe(drawer, { attributes: true, attributeFilter: ["class"] });
    } catch (e) {}
  }

  function forceOpen(drawer) {
    if (!drawer) return;
    injectStickyHideCss();
    bumpDrawerZ(drawer);
    markOpen();
    ensureCloseObserver(drawer);

    var opened = false;
    try {
      if (typeof drawer.open === "function") {
        drawer.open();
        opened = true;
      }
    } catch (e) {
      opened = false;
    }
    /* Always ensure classes even if drawer.open threw or no-oped. */
    try {
      drawer.classList.add("animate", "active");
      document.body.classList.add("overflow-hidden");
    } catch (e2) {}
    bumpDrawerZ(drawer);
    markOpen();
    return opened;
  }

  function rebindOverlay(drawer) {
    if (!drawer) return;
    var overlay = drawer.querySelector("#CartDrawer-Overlay");
    if (!overlay) return;
    if (typeof drawer.close === "function") {
      overlay.addEventListener("click", drawer.close.bind(drawer));
    } else {
      overlay.addEventListener("click", function () {
        drawer.classList.remove("active");
        markClosed();
      });
    }
  }

  function updateBubble(sectionHtml) {
    var bubble = document.getElementById("cart-icon-bubble");
    if (!bubble || !sectionHtml) return;
    try {
      var b = new DOMParser().parseFromString(sectionHtml, "text/html");
      var sectionEl = b.querySelector(".shopify-section") || b.body;
      if (sectionEl) bubble.innerHTML = sectionEl.innerHTML;
    } catch (e) {}
  }

  function applyDrawerHtml(drawer, sectionHtml) {
    if (!drawer || !sectionHtml) return;
    try {
      var html = new DOMParser().parseFromString(sectionHtml, "text/html");
      var fresh = html.querySelector("cart-drawer");
      if (!fresh) return;
      drawer.innerHTML = fresh.innerHTML;
      if (fresh.classList.contains("is-empty")) drawer.classList.add("is-empty");
      else drawer.classList.remove("is-empty");
      rebindOverlay(drawer);
    } catch (e) {}
  }

  /**
   * Refresh cart-drawer (+ optional icon bubble) from root ?sections= and open it.
   * Always resolves (never rejects) so ATC callers never fall through to form submit.
   */
  w.fllOpenCartDrawer = function fllOpenCartDrawer() {
    var drawer = document.querySelector("cart-drawer");
    var bubble = document.getElementById("cart-icon-bubble");
    var wanted = [];
    if (drawer) wanted.push("cart-drawer");
    if (bubble) wanted.push("cart-icon-bubble");

    /* Open immediately so the drawer appears even if section fetch is slow/fails. */
    forceOpen(drawer);

    try {
      document.dispatchEvent(new CustomEvent("fll:cart-changed"));
    } catch (e) {}

    if (!wanted.length) {
      return Promise.resolve(false);
    }

    return fetch(rootUrl() + "?sections=" + wanted.join(","))
      .then(function (r) {
        if (!r.ok) throw new Error("sections " + r.status);
        return r.json();
      })
      .then(function (sections) {
        drawer = document.querySelector("cart-drawer") || drawer;
        if (sections && sections["cart-drawer"] && drawer) {
          applyDrawerHtml(drawer, sections["cart-drawer"]);
          forceOpen(drawer);
        } else {
          forceOpen(drawer);
        }
        if (sections && sections["cart-icon-bubble"]) {
          updateBubble(sections["cart-icon-bubble"]);
        }
        try {
          document.dispatchEvent(new CustomEvent("fll:cart-changed"));
        } catch (e2) {}
        return true;
      })
      .catch(function (err) {
        try {
          console.warn("[fll] open cart drawer refresh failed", err);
        } catch (e3) {}
        forceOpen(document.querySelector("cart-drawer"));
        return false;
      });
  };
})(typeof window !== "undefined" ? window : this);
